import { createSlice } from '@reduxjs/toolkit'

interface DiagnosisState {
  currentPatient: any | null
  diagnosisRecords: any[]
}

const initialState: DiagnosisState = {
  currentPatient: null,
  diagnosisRecords: [],
}

const diagnosisSlice = createSlice({
  name: 'diagnosis',
  initialState,
  reducers: {
    setCurrentPatient: (state, action) => {
      state.currentPatient = action.payload
    },
    setDiagnosisRecords: (state, action) => {
      state.diagnosisRecords = action.payload
    },
  },
})

export const { setCurrentPatient, setDiagnosisRecords } = diagnosisSlice.actions
export default diagnosisSlice.reducer

